import React, { useState, useEffect, useRef, useContext, useMemo } from 'react'
import { withRouter } from 'react-router-dom'
import {
    Container,
    Form,
    Button,
    Row,
    Col,
    Card,
    Input,
    CardBody,
    FormGroup,
    Label,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    CardFooter,
} from 'reactstrap'
import { connect } from 'react-redux'
import { isEmpty, remove, find, map, head, uniqBy, get, filter } from 'lodash'
import {
    useStripe,
    useElements,
    CardNumberElement,
    CardCvcElement,
    CardExpiryElement
} from '@stripe/react-stripe-js'
import CurrencyFormat from 'react-currency-format'
import { isMobile } from 'react-device-detect'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'
import moment from 'moment'
import 'moment/min/locales'
import ProductCard from "../../../components/Common/ProductCard"
import {
    getUrlOfDefaultProductImage,
    getImagesOfProduct,
    getImageBrandCard
} from '../../../helpers/utils'
import useResponsiveFontSize from '../../../helpers/useResponsiveFontSize'
import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'
import orderConfirmedImg from '../../../assets/images/orders/orderconfirmed-logo.png'
import orderEnvioImg from '../../../assets/images/orders/envio.png'

moment.locale('es')

const useOptions = () => {
    const fontSize = useResponsiveFontSize()
    const options = useMemo(
        () => ({
            style: {
                base: {
                    color: '#424770',
                    fontSize,
                    letterSpacing: "0.025em",
                    "::placeholder": {
                        color: "#868b8f"
                    }
                },
                invalid: {
                    color: "#9e2146"
                }
            }
        }),
        [fontSize]
    )
    return options
}

const FormPage = (props) => {
    const generalContext = useContext(GeneralContext)
    const { loading, setLoading } = generalContext

    const stripe = useStripe()
    const elements = useElements()
    const options = useOptions()

    const inputCodigoRef = useRef(null)
    const [modal, setModal] = useState(false)
    const [saveOrderModal, setSaveOrderModal] = useState(false)
    const [deleteOrderModal, setDeleteOrderModal] = useState(false)
    const [itemToDelete, setItemToDelete] = useState({})
    const [orderConfirmedModal, setOrderConfirmedModal] = useState(false)
    const [resumeModal, setResumeModal] = useState(false)
    const [userAddressModal, setUserAddressModal] = useState(false)
    const [selectProductModal, setSelectProductModal] = useState(false)
    const [supplierInDraftModal, setSupplierInDraftModal] = useState(false)
    const [paymentModal, setPaymentModal] = useState(false)
    const [payOrderModal, setPayOrderModal] = useState(false)
    const [orderIdCreated, setOrderIdCreated] = useState('')
    const [clientSecret, setClientSecret] = useState('')
    const [cardHolderName, setCardHolderName] = useState('')

    const [order, setOrder] = useState({})
    const [orderConfirmed, setOrderConfirmed] = useState({})
    const [settings, setSettings] = useState({})
    const [paymentMethods, setPaymentMethods] = useState([])
    const [productsTypeAhead, setProductsTypeAhead] = useState([])
    const [taLoading, setTaLoading] = useState(false)

    const [suppliers, setSuppliers] = useState([])
    const [supplierId, setSupplierId] = useState('')
    const [temporalSupplierId, setTemporalSupplierId] = useState('')
    const [userAddress, setUserAddress] = useState([])
    const [userAddressId, setUserAddressId] = useState('')
    const [ordersInDraft, setOrdersInDraft] = useState([])
    const [supplierName, setSupplierName] = useState('')
    const [orderTemporal, setOrderTemporal] = useState({})

    const [productSearched, setProductSearched] = useState({})
    const [quantity, setQuantity] = useState(1)
    const [isEditingProduct, setIsEditingProduct] = useState(false)

    const [firstVariants, setFirstVariants] = useState([])
    const [firstVariantValue, setFirstVariantValue] = useState('')
    const [secondVariants, setSecondVariants] = useState([])
    const [secondVariantValue, setSecondVariantValue] = useState('')
    const [thirdVariants, setThirdVariants] = useState([])
    const [thirdVariantValue, setThirdVariantValue] = useState('')

    const [orderList, setOrderList] = useState([])

    const [deliveryCost, setDeliveryCost] = useState(0)
    const [totalToPay, setTotalToPay] = useState(0)

    const [calle, setCalle] = useState('')
    const [numeroExterior, setNumeroExterior] = useState('')
    const [numeroInterior, setNumeroInterior] = useState('')
    const [colonia, setColonia] = useState('')
    const [cp, setCp] = useState('')
    const [entreCalles, setEntreCalles] = useState('')
    const [localidad, setLocalidad] = useState('')
    const [municipio, setMunicipio] = useState('')
    const [states, setStates] = useState([])
    const [stateId, setStateId] = useState('')
    const [countries, setCountries] = useState([])
    const [countryId, setCountryId] = useState('')

    const [selectedPayType, setSelectedPayType] = useState('')
    const [brandOfCard, setBrandOfCard] = useState('')
    const [cardInputInvalid, setCardInputInvalid] = useState(true)
    const [expirationInputInvalid, setExpirationInputInvalid] = useState(true)
    const [cvvInputInvalid, setCvvInputInvalid] = useState(true)

    const orderId = get(props, 'match.params.id', false)
    const supplierSelectedId = get(props, 'match.params.supplierId', false)

    const toggleSupplierModal = () => setModal(!modal)
    const togglePaymentModal = () => setPaymentModal(!paymentModal)
    const togglePayOrderModal = () => setPayOrderModal(!payOrderModal)
    const toggleResumeModal = () => setResumeModal(!resumeModal)
    const toggleSaveOrderModal = () => setSaveOrderModal(!saveOrderModal)
    const toggleUserAddressModal = () => setUserAddressModal(!userAddressModal)
    const toggleDeleteOrderModal = () => setDeleteOrderModal(!deleteOrderModal)
    const toggleSelectProductModal = () => setSelectProductModal(!selectProductModal)
    const toggleOrderConfirmedModal = () => setOrderConfirmedModal(!orderConfirmedModal)
    const toggleSupplierInDraftModal = () => setSupplierInDraftModal(!supplierInDraftModal)

    const fetchUserAddress = async () => {
        setLoading(true)
        const response = await ApiService.getAllUserAddress()
        let data = []
        response.data.data.map((item) => {
            const itemData = {
                value: item.id,
                label: `
                    ${item.calle} 
                    ${item.numeroExterior} 
                    ${item.numeroInterior} 
                    ${item.colonia} 
                    ${item.cp} 
                    ${item.entreCalles} 
                    ${item.localidad} 
                    ${item.municipio} 
                    ${item.state.nomEstado} 
                    ${item.country.nameEn}
                `,
            }
            return data.push(itemData)
        })
        setLoading(false)
        setUserAddress(data)
    }

    async function fetchSuppliers() {
        try {
            setLoading(true)
            const response = await ApiService.getSuppliersForOrder()
            if (response.data.suppliers) {
                let suppliers = []
                response.data.suppliers.map((supplier) => {
                    const item = {
                        value: supplier.id,
                        label: supplier.nombreComercial,
                    }
                    return suppliers.push(item)
                })
                setSuppliers(suppliers)
            }   
            setOrdersInDraft(response.data.ordersInDraft ? response.data.ordersInDraft : [])
            setLoading(false)
        } catch(e) {
            toastr.error(`${e.response.data.message}`, 'Error')
            setLoading(false)
        }
    }

    useEffect(() => {
        (async () => {
            await fetchSuppliers()
            await fetchUserAddress()
            await fetchCountries()
        })()

        async function fetchCountries() {
            setLoading(true)
            const response = await ApiService.getCountries('MX')
            let countries = []
            response.data.data.map((item) => {
                const row = {
                    value: item.id,
                    label: item.nameEn,
                }
                return countries.push(row)
            })
            setCountries(countries)
            if (countries.length === 1) {
                setCountryId(head(countries).value)
            }
            setLoading(false)
        }
    }, []) // eslint-disable-line

    useEffect(() => {
        (async () => {
            if (orderId) {
                await fetchOrderDetail(orderId)
            }
        })()

        async function fetchOrderDetail(id) {
            setLoading(true)
            const response = await ApiService.getDetailOfOrderByUser(id)
            setOrder(response.data.order)
            setOrderList(response.data.data)
            if (!isEmpty(response.data.order.userAddress)) {
                setUserAddressId(response.data.order.userAddress.id)
            }
            setSupplierId(response.data.order.supplier.id)
            setLoading(false)
        }
    }, [orderId]) // eslint-disable-line

    useEffect(() => {
        calculateTotals()
    }, [orderList, order]) // eslint-disable-line

    useEffect(() => {
        inputCodigoRef.current.focus()
    }, [supplierId])

    useEffect(() => {
        setSupplierId(supplierSelectedId)
    }, [supplierSelectedId])

    useEffect(() => {
        (async () => {
            if (!isEmpty(countryId)) {
                await fetchStates(countryId)
            }
        })()
    
        async function fetchStates() {
            setLoading(true)
            const response = await ApiService.getStatesByCountry(countryId)
            let states = []
            response.data.data.map((item) => {
                const row = {
                    value: item.id,
                    label: item.nomEstado,
                }
                return states.push(row)
            })
            setStates(states)
            setLoading(false)
        }
    }, [countryId]) // eslint-disable-line

    const simpleCloseSupplierInDraftModal = () => {
        setSupplierName('')
        toggleSupplierInDraftModal()
    }

    const deleteOrderInDraft = async () => {
        try {
            setLoading(true)
            const ordersInDraftDeleted = await ApiService.deleteOrder(orderTemporal.id)
            if (ordersInDraftDeleted.data.success) {
                toastr.success(`El pedido fue eliminado.`, '¡Éxito!')
                setOrderTemporal({})
                toggleSupplierInDraftModal()
                await fetchSuppliers()
                setLoading(false)
            }
        } catch(e) {
            toastr.error(`${e.response.data.message}`, 'Error')
            setLoading(false)
        }
    }

    const goToOrderToEdit = () => {
        props.history.push(`/pedidos/editar/${orderTemporal.id}`)
    }

    const verifySupplier = (selectedSupplierId) => {
        const supplier = filter(suppliers, { value: selectedSupplierId })
        setSupplierName(head(supplier).label)
        const hasOrderInDraft = filter(ordersInDraft, {
            status: {
                codeName: 'BORRADOR'
            },
            supplierId: selectedSupplierId
        })
        if (!isEmpty(hasOrderInDraft)) {
            setSupplierId(selectedSupplierId)
            setOrderTemporal(head(hasOrderInDraft))
            toggleSupplierInDraftModal()
            return
        }
        if (isEmpty(orderList)) {
            setSupplierId(selectedSupplierId)
            setProductSearched({})
            setQuantity(1)
            setFirstVariantValue('')
            setSecondVariantValue('')
            setThirdVariantValue('')
        } else {
            setTemporalSupplierId(selectedSupplierId)
            toggleSupplierModal()
        }
    }

    const setSupplier = async () => {
        toggleSupplierModal()
        if (isEmpty(orderId)) {
            await saveOrder('BORRADOR')
        }
        await fetchSuppliers()
        setProductSearched({})
        setQuantity(1)
        setFirstVariantValue('')
        setSecondVariantValue('')
        setThirdVariantValue('')
        setOrderList([])
        setSupplierId(temporalSupplierId)
    }

    const searchProductsBySupplierAndFilter = async (filter) => {
        try {
            setLoading(true)
            setTaLoading(true)
            const textToSearch = filter.replace(/%/gi, '').trim()
            if (!isEmpty(textToSearch)) {
                const response = await ApiService.getProductsBySupplierAndFilter(supplierId, textToSearch.toUpperCase())
                if (response.data.success) {
                    if (!isEmpty(response.data.data)) {
                        setProductsTypeAhead(response.data.data)
                    } else {
                        inputCodigoRef.current.focus()
                        setProductsTypeAhead([])
                    }
                }
            }
        } catch (e) {
            if (e.response) {
                toastr.error(`${e.response.data.message}`, 'Error')
            } else {
                toastr.error(`${e}`, 'Error')
            }
        } finally {
            setLoading(false)
            setTaLoading(false)
        }
    }

    const selectProductSearched = (productArray) => {
        setProductsTypeAhead([])
        const product = head(productArray)
        setProductSearched(product)
        if (!isEmpty(product.variants)) {
            setVariantsOfItem(product)
        }
        toggleSelectProductModal()
        inputCodigoRef.current.clear()
    }

    const addProductToOrderList = () => {
        // Eliminar de la lista producto editado
        const temporalOrderList = orderList
        remove(temporalOrderList, n =>
            n.id === productSearched.id &&
            n.firstVariantSelected === productSearched.firstVariantSelected &&
            n.secondVariantSelected === productSearched.secondVariantSelected &&
            n.thirdVariantSelected === productSearched.thirdVariantSelected
        )
        const variantSelId = find(productSearched.variants, {
            firstOption: {
                value: firstVariantValue
            },
            secondOption: {
                value: secondVariantValue
            },
            thirdOption: {
                value: thirdVariantValue
            }
        })
        remove(temporalOrderList, n =>
            n.productId === productSearched.id &&
            n.productVariantId === variantSelId.id
        )
        setOrderList([...temporalOrderList])

        // Agregar nuevas configuraciones de producto
        const newOrderList = orderList
        let productToAdd = find(newOrderList, {
            id: productSearched.id,
            firstVariantSelected: firstVariantValue,
            secondVariantSelected: secondVariantValue,
            thirdVariantSelected: thirdVariantValue,
        })
        if (!isEmpty(productToAdd)) {
            remove(newOrderList, n =>
                n.id === productSearched.id &&
                n.firstVariantSelected === firstVariantValue &&
                n.secondVariantSelected === secondVariantValue &&
                n.thirdVariantSelected === thirdVariantValue
            )
            productToAdd.quantity += parseInt(quantity)
        } else {
            productToAdd = productSearched
            productToAdd.quantity = parseInt(quantity)
        }
        productToAdd.firstVariantSelected = firstVariantValue
        productToAdd.secondVariantSelected = secondVariantValue
        productToAdd.thirdVariantSelected = thirdVariantValue
        const variantsOfProductToAdd = productToAdd.variants
        const variantSelected = find(variantsOfProductToAdd, {
            firstOption: {
                value: firstVariantValue
            },
            secondOption: {
                value: secondVariantValue
            },
            thirdOption: {
                value: thirdVariantValue
            }
        })
        productToAdd.productVariantId = variantSelected.id
        newOrderList.push(productToAdd)
        setOrderList(newOrderList)
        setProductSearched({})
        setQuantity(1)
        setIsEditingProduct(false)
        setFirstVariantValue('')
        setSecondVariantValue('')
        setThirdVariantValue('')
        toggleSelectProductModal()
        calculateTotals()
    }

    const calculateTotals = () => {
        if (!isEmpty(orderList)) {
            let totalSum = 0
            for (const item of orderList) {
                const product = !isEmpty(item.product) ? item.product : item
                totalSum += parseFloat(product.wholeSalePrice) * parseInt(item.quantity)
            }
            const deliveryCostToPay =
                isEmpty(orderId)
                    ? parseFloat(head(orderList).supplier.costoEnvioEstandar)
                    : parseFloat(order.supplier.costoEnvioEstandar)
            setDeliveryCost(deliveryCostToPay)
            const totalToPayOrder = deliveryCostToPay + totalSum
            setTotalToPay(totalToPayOrder.toFixed(2))
        }
    }

    const validateButtonToAddProductToOrderList = () => {
        if (parseInt(quantity) < 1) return true
        if (!isEmpty(firstVariants)) {
            if (isEmpty(firstVariantValue) || firstVariantValue === '0') {
                return true
            }
        }
        if (!isEmpty(secondVariants)) {
            if (isEmpty(secondVariantValue) || secondVariantValue === '0') {
                return true
            }
        }
        if (!isEmpty(thirdVariants)) {
            if (isEmpty(thirdVariantValue) || thirdVariantValue === '0') {
                return true
            }
        }
        return false
    }

    const validateIfCardIsDisabled = () => {
        if (!isEmpty(productSearched)) {
            return productSearched.status.codeName !== 'ACTIVO' ||
                parseFloat(productSearched.wholeSalePrice) === 0
        }
    }

    const setVariantsOfItem = (item) => {
        const firstOption = []
        const secondOption = []
        const thirdOption = []
        map(item.variants, (i) => {
            if (!isEmpty(i.firstOption.value)) {
                firstOption.push({
                    label: i.firstOption.value,
                    value: i.firstOption.value
                })
            }
            if (!isEmpty(i.secondOption.value)) {
                secondOption.push({
                    label: i.secondOption.value,
                    value: i.secondOption.value
                })
            }
            if (!isEmpty(i.thirdOption.value)) {
                thirdOption.push({
                    label: i.thirdOption.value,
                    value: i.thirdOption.value
                })
            }
        })
        // Eliminar variantes repetidas
        const uniqFirstOption = uniqBy(firstOption, 'value')
        const uniqSecondOption = uniqBy(secondOption, 'value')
        const uniqThirdOption = uniqBy(thirdOption, 'value')
        // Asignar
        setFirstVariants(uniqFirstOption)
        if (uniqFirstOption.length === 1) {
            setFirstVariantValue(head(uniqFirstOption).value)
        }
        setSecondVariants(uniqSecondOption)
        if (uniqSecondOption.length === 1) {
            setSecondVariantValue(head(uniqSecondOption).value)
        }
        setThirdVariants(uniqThirdOption)
        if (uniqThirdOption.length === 1) {
            setThirdVariantValue(head(uniqThirdOption).value)
        }
    }

    const editProductOfList = item => {
        if (!isEmpty(orderId)) {
            if (!isEmpty(item.product)) {
                setVariantsOfItem(item.product)
            } else {
                setVariantsOfItem(item)
            }
        }
        setIsEditingProduct(true)
        setProductSearched(isEmpty(item.product) ? item : item.product)
        setQuantity(item.quantity)
        setFirstVariantValue(!isEmpty(item.productVariant) ? item.productVariant.firstOption.value : item.firstVariantSelected )
        setSecondVariantValue(!isEmpty(item.productVariant) ? item.productVariant.secondOption.value : item.secondVariantSelected)
        setThirdVariantValue(!isEmpty(item.productVariant) ? item.productVariant.thirdOption.value : item.thirdVariantSelected)
        toggleSelectProductModal()
    }

    const confirmDeleteProductOfList = item => {
        setItemToDelete(item)
        toggleDeleteOrderModal()
    }

    const deleteProductOfList = () => {
        const newOrderList = orderList
        remove(newOrderList,
            n => n.id === itemToDelete.id &&
            n.firstVariantSelected === itemToDelete.firstVariantSelected &&
            n.secondVariantSelected === itemToDelete.secondVariantSelected &&
            n.thirdVariantSelected === itemToDelete.thirdVariantSelected
        )
        setOrderList([...newOrderList])
        toggleDeleteOrderModal()
        calculateTotals()
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        toggleResumeModal()
    }

    const payOrder = async () => {
        if (!stripe || !elements) {
            console.log('stripe js not loaded yet')
            toastr.error(`stripe js not loaded yet`, 'Error')
            return
        }
        try {
            setLoading(true)
            togglePayOrderModal()
            const result = await stripe.confirmCardPayment(clientSecret, {
                payment_method: {
                    card: elements.getElement(CardNumberElement),
                    billing_details: {
                        name: cardHolderName,
                    },
                }
            });
            if (result.error) {
                toastr.error(`${result.error.message}`, 'Error')
                return
            } else {
                if (result.paymentIntent.status === 'succeeded') {
                    setClientSecret('')
                    // Actualizar orden a pagado
                    const orderUpdated =
                        await ApiService.markeOrderAsPaid({
                            orderId: orderIdCreated ? orderIdCreated : orderId,
                            paymentIntentId: result.paymentIntent.id,
                            cardHolderName,
                        })
                    if (orderUpdated.data.success) {
                        setOrderConfirmed(orderUpdated.data.order)
                        setSettings(orderUpdated.data.settings)
                        setPaymentMethods(orderUpdated.data.paymentMethods)
                        toggleOrderPaymentModal()
                        toggleResumeModal()
                        toggleOrderConfirmedModal()
                    }
                }
            }
        } catch (e) {
            console.log('error in pay order')
            console.log(e)
            toastr.error(`${e.error.message}`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    const saveOrder = async (mode) => {
        const productList = []
        map(orderList, (i) => {
            const item = {
                wholeSalePrice: i.wholeSalePrice || i.product.wholeSalePrice,
                quantity: i.quantity,
                id: isEmpty(i.product) ? i.id : i.product.id,
                buyPrice: i.buyPrice || i.product.buyPrice,
                productVariantId: i.productVariantId || i.productVariant.id,
            }
            productList.push(item)
        })
        const data = {
            notes: '',
            supplierId,
            orderList: productList,
            userAddressId,
            mode,
            payWithCard: selectedPayType === 'PAGO_EN_LINEA',
        }
        setLoading(true)
        try {
            if (!isEmpty(orderId) || !isEmpty(orderIdCreated)) { 
                data.id = orderId || orderIdCreated
                const response = await ApiService.updateOrder(data)
                if (response.data.success) {
                    if (isEmpty(mode)) {
                        toastr.success(`El pedido fue editado correctamente.`, '¡Éxito!')
                        setOrderConfirmed(response.data.order)
                        setSettings(response.data.settings)
                        setPaymentMethods(response.data.paymentMethods)
                        toggleOrderConfirmedModal()
                    } else if (mode === 'PENDIENTE_DE_PAGO') {
                        setOrderIdCreated(response.data.orderIdCreated)
                        return response.data.orderIdCreated
                    }
                }
                return
            }

            const response = await ApiService.createOrder(data)
            if (!isEmpty(response.data)) {
                if (response.data.success) {
                    if (isEmpty(mode)) {
                        toastr.success(`El pedido fue guardado.`, '¡Éxito!')
                        setOrderConfirmed(response.data.order)
                        setSettings(response.data.settings)
                        setPaymentMethods(response.data.paymentMethods)
                        toggleOrderConfirmedModal()
                    } else if (mode === 'BORRADOR') {
                        toastr.success(`El pedido fue guardado como borrador.`, '¡Éxito!')
                    } else if (mode === 'PENDIENTE_DE_PAGO') {
                        setOrderIdCreated(response.data.orderIdCreated)
                        return response.data.orderIdCreated
                    }
                }
            }
        } catch(e) {
            toastr.error(`${e.response.data.message}`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    const goToOrders = () => {
        toggleOrderConfirmedModal()
        setOrderConfirmed({})
        setPaymentMethods([])
        setSettings({})
        props.history.push(`/pedidos`)
    }

    const createUserAddress = () => {
        toggleUserAddressModal()
    }

    const enableSaveUserAddressButton = () => {
        if (isEmpty(calle) ||
            isEmpty(numeroExterior) ||
            isEmpty(colonia) ||
            isEmpty(cp) ||
            isEmpty(localidad) ||
            isEmpty(municipio) ||
            isEmpty(stateId) ||
            stateId === '0' ||
            isEmpty(countryId) ||
            countryId === '0') {
                return true
        }
        return false
    }

    const saveUserAddress = async () => {
        setLoading(true)
        const data = {
            calle,
            numeroExterior,
            numeroInterior,
            cp,
            colonia,
            entreCalles,
            localidad,
            municipio,
            stateId,
            countryId
        }
        const response = await ApiService.createUserAddress(data).catch(error => {
            toastr.error(`No pude crear la dirección de envío ${error}`, 'Error')
            setLoading(false)
            return
        })
        if (!isEmpty(response.data)) {
            if (response.data.success) {
                toastr.success(`Dirección de envío guardada correctamente.`, '¡Éxito!')
            }
        }
        setLoading(false)
        fetchUserAddress()
        toggleUserAddressModal()
    }

    const resumeOrderNextStep = async () => {
        try {
            if (selectedPayType === 'PAGO_EN_LINEA') {
                setLoading(true)
                let orderCreatedId = ''
                if (orderId) {
                    orderCreatedId = orderId
                    await saveOrder('PENDIENTE_DE_PAGO')
                } else {
                    orderCreatedId = await saveOrder('PENDIENTE_DE_PAGO')
                }
                setLoading(true)
                const paymentIntent =
                    await ApiService.createIntentOfPayment({
                        orderId: isEmpty(orderIdCreated) ? orderCreatedId : orderIdCreated
                    })
                setClientSecret(paymentIntent.data.client_secret)
                toggleOrderPaymentModal()
            } else {
                toggleSaveOrderModal()
            }
        } catch (e) {
            toastr.error(`${e.response.data.message}`, 'Error')
        } finally {
            setLoading(false)
        }
    }

    const payOrderToggleModal = (e) => {
        e.preventDefault()
        togglePayOrderModal()
    }

    const toggleOrderPaymentModal = () => {
        togglePaymentModal()
        setBrandOfCard('')
    }

    const disabledByStatus = () => {
        if (!isEmpty(order)) {
            if (order.status.codeName === 'PENDIENTE_DE_PAGO') {
                return false
            }
            if (order.status.codeName === 'BORRADOR') {
                return false
            }
            return true
        }
        return false
    }

    return (
        <React.Fragment>
            <Form id="create" method="POST" onSubmit={ handleSubmit }>
                <Row>
                    <Col xs={12}>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={5}>
                                        <FormGroup>
                                            <Input
                                                type="select"
                                                className="custom-select"
                                                value={supplierId}
                                                id="supplier"
                                                name="supplier"
                                                disabled={disabledByStatus()}
                                                onChange={(event) => {
                                                    verifySupplier(event.target.value)
                                                }}>
                                                    <option key="0" value="0">Seleccione un proveedor... </option> 
                                                    {suppliers.map((item, i) => {
                                                        return (
                                                            <option key={i} value={item.value}>{item.label}</option>
                                                        )
                                                    })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col sm={7}>
                                        <FormGroup>
                                            <AsyncTypeahead
                                                filterBy={() => true}
                                                disabled={
                                                    isEmpty(supplierId) ||
                                                    disabledByStatus()
                                                }
                                                id="codigo"
                                                ref={inputCodigoRef}
                                                isLoading={taLoading}
                                                labelKey="productCode"
                                                minLength={3}
                                                onChange={selectProductSearched}
                                                onSearch={searchProductsBySupplierAndFilter}
                                                options={productsTypeAhead}
                                                placeholder="Busca tus productos..."
                                                searchText="Buscando..."
                                                promptText="Buscando..."
                                                emptyLabel="Producto no encontrado"
                                                useCache={false}
                                                renderMenuItemChildren={(i, props) => (
                                                    <React.Fragment>
                                                        <img
                                                            alt={i.name}
                                                            src={
                                                                !isEmpty(i.gallery) ? head(i.gallery).fileName : getUrlOfDefaultProductImage()
                                                            }
                                                            style={{
                                                                height: '24px',
                                                                marginRight: '10px',
                                                                width: '24px',
                                                            }}
                                                        />
                                                        <span>{i.supplierCode} - {i.name}</span>
                                                    </React.Fragment>
                                                )}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        { !isEmpty(orderList) && orderList.map((item, key) => (
                            <Card key={`grid_${key}`}>
                                <CardBody>
                                    <Row>
                                        <Col sm={ isMobile ? '6' : '5' }>
                                            <div style={{ display: 'inline-flex', minHeight: '1px' }}>
                                                <img
                                                    src={!isEmpty(item.gallery) ? head(item.gallery).fileName : !isEmpty(item.product.gallery) ? head(item.product.gallery).fileName : getUrlOfDefaultProductImage()}
                                                    alt=""
                                                    width="50px"
                                                    height="50px"
                                                    style={{ marginBottom: '10px', marginRight: isMobile ? '5px' : '10px' }}
                                                />
                                                <div className="d-block">
                                                    <div style={{ fontWeight: '600' }}>{item.name || item.product.name}</div>
                                                    {
                                                        !isEmpty(item.firstVariantSelected) && (
                                                            <span style={{ color: 'gray' }}>
                                                                Color: {`${item.firstVariantSelected} `}
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        !isEmpty(item.productVariant) &&
                                                        !isEmpty(item.productVariant.firstOption) &&
                                                        !isEmpty(item.productVariant.firstOption.value) && (
                                                            <span style={{ color: 'gray' }}>
                                                                {item.productVariant.firstOption.label}: {`${item.productVariant.firstOption.value} `}
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        !isEmpty(item.secondVariantSelected) && (
                                                            <span style={{ color: 'gray' }}>
                                                                - Talla: {`${item.secondVariantSelected} `}
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        !isEmpty(item.productVariant) &&
                                                        !isEmpty(item.productVariant.secondOption) &&
                                                        !isEmpty(item.productVariant.secondOption.value) && (
                                                            <span style={{ color: 'gray' }}>
                                                                - {item.productVariant.secondOption.label}: {`${item.productVariant.secondOption.value} `}
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        !isEmpty(item.thridVariantSelected) && (
                                                            <span style={{ color: 'gray' }}>
                                                                - Presentación: {item.thridVariantSelected}
                                                            </span>
                                                        )
                                                    }
                                                    {
                                                        !isEmpty(item.productVariant) &&
                                                        !isEmpty(item.productVariant.thirdOption) &&
                                                        !isEmpty(item.productVariant.thirdOption.value) && (
                                                            <span style={{ color: 'gray' }}>
                                                                - {item.productVariant.thirdOption.label}: {item.productVariant.thirdOption.value}
                                                            </span>
                                                        )
                                                    }
                                                    <div style={{ marginTop: isMobile ? '5px' : '0px' }}>Código: <label>{item.supplierCode || item.product.supplierCode}</label></div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col sm="2">
                                            <div style={{ marginLeft: isMobile ? '60px' : '0px' }}>
                                                <CurrencyFormat
                                                    value={!isEmpty(item.wholeSalePrice) ? item.wholeSalePrice : item.product.wholeSalePrice}
                                                    displayType="text"
                                                    renderText={value => (<div>Precio unitario: {value}</div>)}
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </div>
                                        </Col>
                                        <Col sm="4">
                                            <Row>
                                                <Col 
                                                    className="text-left" 
                                                    style={{ marginLeft: isMobile ? '60px' : '0px', marginTop: isMobile ? '7px' : '0px'}}
                                                >
                                                    Cantidad: {item.quantity}
                                                </Col>
                                                <Col className="text-right font-size-20">
                                                    <CurrencyFormat
                                                        value={!isEmpty(item.wholeSalePrice) ? parseFloat(item.wholeSalePrice) * parseInt(item.quantity) : parseFloat(item.product.wholeSalePrice) * parseInt(item.quantity)}
                                                        displayType="text"
                                                        thousandSeparator
                                                        prefix="$"
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                        { !isMobile && (
                                            <Col sm="1">
                                                <UncontrolledDropdown>
                                                    <DropdownToggle href="#" disabled={disabledByStatus()} className="card-drop cursor-pointer" tag="i">
                                                        <i className="mdi mdi-dots-horizontal font-size-18"></i>
                                                    </DropdownToggle>
                                                    <DropdownMenu right>
                                                        <DropdownItem onClick={() => editProductOfList(item)}>
                                                            <i className="mdi mdi-pencil font-size-16 text-success mr-2"></i> Editar
                                                        </DropdownItem>
                                                        <DropdownItem onClick={() => confirmDeleteProductOfList(item)}>
                                                            <i className="mdi mdi-trash-can font-size-16 text-danger mr-2"></i> Eliminar
                                                        </DropdownItem>
                                                    </DropdownMenu>
                                                </UncontrolledDropdown>
                                            </Col>
                                        )}
                                    </Row>
                                </CardBody>
                                { isMobile && (
                                    <CardFooter
                                        className="bg-transparent border-top"
                                        style={{ textAlign: 'center' }}
                                    >
                                        <div className="d-flex">
                                            <div className="flex-fill">
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 m-0 d-inline align-baseline"
                                                    disabled={disabledByStatus()}
                                                    onClick={() => editProductOfList(item)}
                                                    style={{ color: 'black' }}
                                                >
                                                    <i className="mdi mdi-pencil font-size-16 text-success mr-2"></i> Editar
                                                </button>
                                            </div>
                                            <div className="flex-fill">
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0 m-0 d-inline align-baseline"
                                                    disabled={disabledByStatus()}
                                                    onClick={() => confirmDeleteProductOfList(item)}
                                                >
                                                    <i className="mdi mdi-trash-can font-size-16 text-danger mr-2"></i> Eliminar
                                                </button>
                                            </div>
                                        </div>
                                    </CardFooter>
                                )}
                            </Card>
                        ))}
                        { !isEmpty(orderList) && !isMobile && (
                            <Card style={{ textAlign: isMobile ? 'right' : 'center' }}>
                                <CardBody>
                                    <Row>
                                        <Col sm={6}>
                                            <CurrencyFormat
                                                value={deliveryCost}
                                                displayType="text"
                                                thousandSeparator
                                                renderText={value => (<div>Envío: <label style={{ fontWeight: 600 }}>{value}</label></div>)}
                                                prefix="$"
                                            />
                                        </Col>
                                        <Col sm={6}>
                                            <CurrencyFormat
                                                value={totalToPay}
                                                displayType="text"
                                                thousandSeparator
                                                renderText={value => (<div>Total con envío: <label style={{ fontWeight: 600 }}>{value}</label></div>)}
                                                prefix="$"
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        )}
                        { !isEmpty(orderList) && isMobile && (
                            <Card style={{ textAlign: isMobile ? 'right' : 'center' }}>
                                <CardBody>
                                    <Row
                                        style={{ borderBottom: '1px solid #f2f2f5', paddingBottom: '10px' }}
                                    >
                                        <Col className="text-left">Envío: </Col>
                                        <Col className="text-right">
                                            <CurrencyFormat
                                                value={deliveryCost}
                                                displayType="text"
                                                thousandSeparator
                                                renderText={value => (<label style={{ fontWeight: 600 }}>{value}</label>)}
                                                prefix="$"
                                            />
                                        </Col>
                                    </Row>
                                    <Row
                                        style={{
                                            fontSize: '14px',
                                            paddingTop: '10px'
                                        }}
                                    >
                                        <Col className="text-left">Total con envío: </Col>
                                        <Col className="text-right">
                                            <CurrencyFormat
                                                value={totalToPay}
                                                displayType="text"
                                                renderText={value => (<label style={{ fontWeight: 600 }}>{value}</label>)}
                                                thousandSeparator
                                                prefix="$"
                                            />
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        )}
                        <Card style={{textAlign: 'right'}}>
                            <CardBody>
                                <Button
                                    onClick={() => { window.history.go(-1) }}
                                    className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                                >
                                    Cancelar
                                </Button>

                                <Button
                                    type="submit"
                                    color="primary"
                                    className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                    disabled={
                                        isEmpty(orderList) ||
                                        disabledByStatus()
                                    }
                                >
                                    <i className={`mdi mdi-check`}></i> Confirmar pedido
                                </Button>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Form>
            <div>
                <Modal isOpen={modal} toggle={toggleSupplierModal}>
                    <ModalHeader toggle={toggleSupplierModal}>Cambio de proveedor</ModalHeader>
                    <ModalBody>
                        Al cambiar de proveedor se eliminarán los productos agregados y tu pedido se guardará como borrador. Recuerda que los borradores se eliminan a las 72 horas ¿Desea confirmar?
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleSupplierModal}>Cancelar</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={setSupplier}>Confirmar</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal isOpen={saveOrderModal} toggle={toggleSaveOrderModal}>
                    <ModalHeader toggle={toggleSaveOrderModal}>Guardar pedido</ModalHeader>
                    <ModalBody>
                        ¿Está seguro que desea guardar su pedido?
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleSaveOrderModal}>Cancelar</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={() => saveOrder(null)}>Confirmar</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal isOpen={payOrderModal} toggle={togglePayOrderModal}>
                    <ModalHeader toggle={togglePayOrderModal}>Completar Pedido</ModalHeader>
                    <ModalBody>
                        ¿Estás lista para pagar tu pedido?
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={togglePayOrderModal}>No, me faltan productos</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={() => payOrder(null)}>Confirmar Pago</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal isOpen={supplierInDraftModal} toggle={simpleCloseSupplierInDraftModal}>
                    <ModalHeader toggle={simpleCloseSupplierInDraftModal}>Borrador de pedido encontrado</ModalHeader>
                    <ModalBody>
                        Ya existe un borrador del proveedor {supplierName}, se cargaran los productos que previamente seleccionaste.
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={deleteOrderInDraft}>Eliminar borrador</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={goToOrderToEdit}>Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal
                    isOpen={selectProductModal}
                    toggle={toggleSelectProductModal}
                    style={{ backgroundColor: 'white' }}
                >
                    <ModalHeader
                        toggle={toggleSelectProductModal}
                        style={{ backgroundColor: 'white' }}
                    >
                        {productSearched.name}
                    </ModalHeader>
                    <ModalBody style={{ backgroundColor: 'white' }}>
                        <ProductCard
                            photos={getImagesOfProduct(
                                productSearched.gallery || []
                            )}
                            code={`${productSearched.supplierCode ? `Código ${productSearched.supplierCode}` : ''}`}
                            price={`${productSearched.wholeSalePrice || 0}`}
                            showVariants
                            variants={productSearched.variants}
                            firstVariantValue={firstVariantValue}
                            secondVariantValue={secondVariantValue}
                            thirdVariantValue={thirdVariantValue}
                            onChangeFirstVariant={setFirstVariantValue}
                            onChangeSecondVariant={setSecondVariantValue}
                            onChangeThirdVariant={setThirdVariantValue}
                            quantity={quantity}
                            onChangeQuantity={setQuantity}
                            showFooterOptions={false}
                            showAddProductButton
                            actionAddProductButton={addProductToOrderList}
                            textAddProductButton={isEditingProduct ? 'Actualizar pedido' : 'Agregar al pedido'}
                            validateAddProductButton={validateButtonToAddProductToOrderList()}
                            disabled={validateIfCardIsDisabled()}
                        />
                    </ModalBody>
                </Modal>
            </div>
            <div>
                <Modal isOpen={paymentModal} toggle={toggleOrderPaymentModal}>
                    <ModalHeader toggle={toggleOrderPaymentModal}>Pago en línea</ModalHeader>
                    <ModalBody>
                        <Form onSubmit={payOrderToggleModal}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm="12">
                                            <FormGroup>
                                                <label style={{ width: '100%' }}>
                                                    Nombre en tarjeta
                                                    <Input
                                                        type="text"
                                                        name="cardHolderName"
                                                        id="cardHolderName"
                                                        className="StripeElement input-like-stripe"
                                                        required
                                                        value={cardHolderName}
                                                        placeholder="Nombre..."
                                                        onChange={(event) => {
                                                            setCardHolderName(event.target.value.toUpperCase())
                                                        }}
                                                    />
                                                </label>
                                            </FormGroup>
                                        </Col>
                                        <Col sm="10">
                                            <FormGroup>
                                                <label style={{ width: '100%' }}>
                                                    Número de tarjeta
                                                    <CardNumberElement
                                                        options={options}
                                                        onChange={event => {
                                                            setBrandOfCard(event.brand)
                                                            if (event.empty || !event.complete || !isEmpty(event.error)) {
                                                                setCardInputInvalid(true)
                                                            } else {
                                                                setCardInputInvalid(false)
                                                            }
                                                        }}
                                                    />
                                                </label>
                                            </FormGroup>
                                        </Col>
                                        <Col sm="2" style={{ marginTop: '24px' }}>
                                            {
                                                !isEmpty(brandOfCard) && !isEmpty(getImageBrandCard(brandOfCard)) && (
                                                    <img
                                                        src={getImageBrandCard(brandOfCard)}
                                                        alt={brandOfCard}
                                                        height="50px"
                                                    />
                                                )
                                            }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm="8">
                                            <FormGroup>
                                                <label style={{ width: '100%' }}>
                                                    Fecha de expiración
                                                    <CardExpiryElement
                                                        options={options}
                                                        onChange={event => {
                                                            if (event.empty || !event.complete || !isEmpty(event.error)) {
                                                                setExpirationInputInvalid(true)
                                                            } else {
                                                                setExpirationInputInvalid(false)
                                                            }
                                                        }}
                                                    />
                                                </label>
                                            </FormGroup>
                                        </Col>
                                        <Col sm="4">
                                            <FormGroup>
                                                <label style={{ width: '100%' }}>
                                                    CVC
                                                    <CardCvcElement
                                                        options={options}
                                                        onChange={event => {
                                                            if (event.empty || !event.complete || !isEmpty(event.error)) {
                                                                setCvvInputInvalid(true)
                                                            } else {
                                                                setCvvInputInvalid(false)
                                                            }
                                                        }}
                                                    />
                                                </label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    <Row className="text-right">
                                        <Col sm="12">
                                            <Button
                                                type="submit"
                                                style={{ width: '100%' }}
                                                color="primary"
                                                className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                                                disabled={!stripe || isEmpty(cardHolderName) || cardInputInvalid || expirationInputInvalid || cvvInputInvalid || loading}>
                                                    <i className="mdi mdi-lock mr-1"></i> Pagar
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <CardFooter>
                                    <Row>
                                        <Col sm="2">
                                            <img
                                                src={getImageBrandCard('visa')}
                                                alt="visa"
                                                height="50px"
                                            />
                                        </Col>
                                        <Col sm="10">
                                            Tus datos de pago en Vendora están protegidos por los más altos estándares de seguridad bancaria.
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Form>
                    </ModalBody>
                </Modal>
            </div>
            <div>
                <Modal isOpen={resumeModal} toggle={toggleResumeModal}>
                    <ModalHeader toggle={toggleResumeModal}>Resumen de pedido</ModalHeader>
                    <ModalBody>
                        <Card>
                            <CardBody>
                                <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Input
                                                type="select"
                                                className="custom-select"
                                                value={userAddressId}
                                                id="userAddress"
                                                name="userAddress"
                                                onChange={(event) => {
                                                    setUserAddressId(event.target.value)
                                                }}>
                                                    <option key="0" value="0">Seleccione una dirección de envío... </option> 
                                                    {userAddress.map((item, i) => {
                                                        return (
                                                            <option key={i} value={item.value}>{item.label}</option>
                                                        )
                                                    })}
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row className="text-left">
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Button
                                                className="btn waves-effect waves-light mb-2 mr-2"
                                                onClick={createUserAddress}
                                            >
                                                <i className="mdi mdi-plus mr-1"></i> Agregar nueva dirección
                                            </Button>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <div className="text-center">
                                    {
                                        !isEmpty(orderList) && orderList.map(item => (
                                            <div key={`resume_${item.id}`}>
                                                <div
                                                    className="product-image-order-confirmed"
                                                    style={{ marginBottom: '150px' }}
                                                >
                                                    <img
                                                        src={
                                                            !isEmpty(item.gallery)
                                                                ? head(item.gallery).fileName
                                                                : !isEmpty(item.product.gallery)
                                                                    ? head(item.product.gallery).fileName
                                                                    : getUrlOfDefaultProductImage()
                                                        }
                                                        alt={item.name}
                                                        width="250px"
                                                        className="img-fluid mx-auto d-block"
                                                    />
                                                </div>
                                                <div>
                                                    <label className="font-weight-bold">{item.name || item.product.name}</label>
                                                    <div>
                                                        {!isEmpty(item.firstVariantSelected) && (
                                                            <span>Color: <label>{item.firstVariantSelected} </label></span>
                                                        )}
                                                        {
                                                            !isEmpty(item.productVariant) &&
                                                            !isEmpty(item.productVariant.firstOption) &&
                                                            !isEmpty(item.productVariant.firstOption.value) && (
                                                                <span>
                                                                    {item.productVariant.firstOption.label}: <label>{`${item.productVariant.firstOption.value} `}</label>
                                                                </span>
                                                            )
                                                        }
                                                        {!isEmpty(item.secondVariantSelected) && (
                                                            <span> - Talla: <label>{item.secondVariantSelected} </label></span>
                                                        )}
                                                        {
                                                            !isEmpty(item.productVariant) &&
                                                            !isEmpty(item.productVariant.secondOption) &&
                                                            !isEmpty(item.productVariant.secondOption.value) && (
                                                                <span>
                                                                    - {item.productVariant.secondOption.label}: <label>{`${item.productVariant.secondOption.value} `}</label>
                                                                </span>
                                                            )
                                                        }
                                                        {!isEmpty(item.thirdVariantSelected) && (
                                                            <span> - Presentación: <label>{item.thirdVariantSelected} </label></span>
                                                        )}
                                                        {
                                                            !isEmpty(item.productVariant) &&
                                                            !isEmpty(item.productVariant.thirdOption) &&
                                                            !isEmpty(item.productVariant.thirdOption.value) && (
                                                                <span>
                                                                    - {item.productVariant.thirdOption.label}: <label>{item.productVariant.thirdOption.value}</label>
                                                                </span>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                <div>
                                                    Cantidad: <label className="font-weight-bold">{item.quantity}</label> - 
                                                    Importe: <label className="font-weight-bold"> 
                                                        <CurrencyFormat
                                                            value={` ${parseFloat((item.wholeSalePrice || item.product.wholeSalePrice)) * parseInt(item.quantity)}`}
                                                            displayType="text"
                                                            thousandSeparator
                                                            prefix="$"
                                                        />
                                                    </label>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>
                            </CardBody>
                        </Card>
                        <Card className="text-center">
                            <CardBody>
                                <Row
                                    style={{ borderBottom: '1px solid #f2f2f5', paddingBottom: '10px' }}
                                >
                                    <Col className="text-left">Envío: </Col>
                                    <Col className="text-right">
                                        <CurrencyFormat
                                            value={deliveryCost}
                                            displayType="text"
                                            thousandSeparator
                                            renderText={value => (<label style={{ fontWeight: 600 }}>{value}</label>)}
                                            prefix="$"
                                        />
                                    </Col>
                                </Row>
                                <Row
                                    style={{
                                        fontSize: '14px',
                                        paddingTop: '10px'
                                    }}
                                >
                                    <Col className="text-left">Total con envío: </Col>
                                    <Col className="text-right">
                                        <CurrencyFormat
                                            value={totalToPay}
                                            displayType="text"
                                            renderText={value => (<label style={{ fontWeight: 600 }}>{value}</label>)}
                                            thousandSeparator
                                            prefix="$"
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <FormGroup tag="fieldset">
                                    <legend>Método de pago</legend>
                                    <Row>
                                        <Col sm="6">
                                            <FormGroup check>
                                                <Label check style={{ cursor: 'pointer' }}>
                                                    <Input
                                                        type="radio"
                                                        name="metododepago"
                                                        value="PAGO_EN_LINEA"
                                                        style={{ cursor: 'pointer' }}
                                                        onChange={(event) => setSelectedPayType(event.target.value) }
                                                    />{' '}
                                                    Pago en línea
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                        <Col sm="6">
                                            <FormGroup check>
                                                <Label check style={{ cursor: 'pointer' }}>
                                                    <Input
                                                        type="radio"
                                                        name="metododepago"
                                                        value="DEPOSITO"
                                                        style={{ cursor: 'pointer' }}
                                                        onChange={(event) => setSelectedPayType(event.target.value) }
                                                    />{' '}
                                                    Transferencia / Depósito
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </CardBody>
                        </Card>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2"
                            onClick={toggleResumeModal}>
                                Cancelar
                        </Button>{' '}
                        <Button
                            color="primary"
                            className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                            disabled={isEmpty(userAddressId) || userAddressId === '0' || isEmpty(selectedPayType)}
                            onClick={resumeOrderNextStep}>
                                Confirmar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal isOpen={userAddressModal} toggle={toggleUserAddressModal}>
                    <ModalHeader toggle={toggleUserAddressModal}>Nueva dirección de envío</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label className="control-label">
                                        Calle *
                                    </Label>
                                    <Input
                                        type="text"
                                        name="calle"
                                        id="calle"
                                        required
                                        value={calle}
                                        placeholder="Calle..."
                                        onChange={(event) => {
                                            setCalle(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label className="control-label">
                                        Numero exterior *
                                    </Label>
                                    <Input
                                        type="text"
                                        name="numeroExterior"
                                        id="numeroExterior"
                                        required
                                        value={numeroExterior}
                                        placeholder="Número exterior..."
                                        onChange={(event) => {
                                            setNumeroExterior(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="numeroInterior">Número interior</Label>
                                    <Input
                                        type="text"
                                        name="numeroInterior"
                                        id="numeroInterior"
                                        value={numeroInterior}
                                        placeholder="Numero interior..."
                                        onChange={(event) => {
                                            setNumeroInterior(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="colonia">Colonia *</Label>
                                    <Input
                                        type="text"
                                        name="colonia"
                                        id="colonia"
                                        value={colonia}
                                        required
                                        placeholder="Colonia..."
                                        onChange={(event) => {
                                            setColonia(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="cp">Código postal *</Label>
                                    <Input
                                        type="number"
                                        name="cp"
                                        id="cp"
                                        required
                                        maxLength="5"
                                        value={cp}
                                        placeholder="Código postal..."
                                        onChange={(event) => {
                                            setCp(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="entreCalles">Entre calles</Label>
                                    <Input
                                        type="text"
                                        name="entreCalles"
                                        required
                                        id="entreCalles"
                                        value={entreCalles}
                                        placeholder="Entre calles..."
                                        onChange={(event) => {
                                            setEntreCalles(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="localidad">Localidad *</Label>
                                    <Input
                                        type="text"
                                        name="localidad"
                                        required
                                        id="localidad"
                                        value={localidad}
                                        placeholder="Localidad..."
                                        onChange={(event) => {
                                            setLocalidad(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label for="municipio">Municipio *</Label>
                                    <Input
                                        type="text"
                                        name="municipio"
                                        id="municipio"
                                        required
                                        value={municipio}
                                        placeholder="Municipio..."
                                        onChange={(event) => {
                                            setMunicipio(event.target.value.toUpperCase())
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label className="control-label">
                                        Estado *
                                    </Label>
                                    <Input
                                        type="select"
                                        className="custom-select"
                                        value={stateId}
                                        id="states"
                                        required
                                        name="states"
                                        onChange={(event) => {
                                            setStateId(event.target.value)
                                        }}>
                                            <option key="0" value="0">Seleccione un estado... </option> 
                                            {states.map((item, i) => {
                                                return (
                                                    <option key={i} value={item.value}>{item.label}</option>
                                                )
                                            })}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <FormGroup>
                                    <Label className="control-label">
                                        País *
                                    </Label>
                                    <Input
                                        type="select"
                                        className="custom-select"
                                        value={countryId}
                                        id="country"
                                        required
                                        name="country"
                                        onChange={(event) => {
                                            setCountryId(event.target.value)
                                        }}>
                                            <option key="0" value="0">Seleccione un país... </option> 
                                            {countries.map((item, i) => {
                                                return (
                                                    <option key={i} value={item.value}>{item.label}</option>
                                                )
                                            })}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button 
                            className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" 
                            onClick={toggleUserAddressModal}>
                                Cancelar
                        </Button>{' '}
                        <Button
                            color="primary"
                            className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2"
                            disabled={enableSaveUserAddressButton()}
                            onClick={saveUserAddress}>
                                Guardar
                        </Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal isOpen={deleteOrderModal} toggle={toggleDeleteOrderModal}>
                    <ModalHeader toggle={toggleDeleteOrderModal}>Eliminar producto</ModalHeader>
                    <ModalBody>
                        ¿Segura que deseas eliminar este producto de tu pedido?
                    </ModalBody>
                    <ModalFooter>
                        <Button className="btn btn-default btn-rounded waves-effect waves-light mb-2 mr-2" onClick={toggleDeleteOrderModal}>No, Cancelar</Button>{' '}
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={deleteProductOfList}>Si, Eliminar</Button>
                    </ModalFooter>
                </Modal>
            </div>
            <div>
                <Modal isOpen={orderConfirmedModal} toggle={goToOrders}>
                    <ModalHeader toggle={goToOrders}>Pedido confirmado</ModalHeader>
                    <ModalBody>
                        <Container>
                            <Card className="text-center">
                                <CardBody>
                                    <img
                                        src={orderConfirmedImg}
                                        alt="Pedido confirmado"
                                        className="img-fluid mx-auto d-block"
                                        width="240px"
                                        height="111px"
                                        style={{ marginBottom: '10px' }}
                                    />
                                    <div style={{ fontSize: '16px' }}>
                                        Hola <label style={{ color: '#e52e6a' }}>{props.user.firstName}</label>
                                    </div>
                                    <div>
                                        Felicidades por tu orden en Vendora de {!isEmpty(orderConfirmed) ? orderConfirmed.supplier.nombreComercial : ''}
                                    </div>
                                    <div>
                                        Tu no. de orden: <label style={{ fontSize: '14px' }}>{!isEmpty(orderConfirmed) ? orderConfirmed.folio : ''}</label>.
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <div
                                        className="font-weight-bold"
                                        style={{ marginBottom: '10px' }}
                                    >
                                        <label style={{ fontSize: '16px' }}>Detalles de tu orden</label>
                                    </div>
                                    <div>
                                        Fecha de compra: <label className="font-weight-bold"> 
                                            {
                                                !isEmpty(orderConfirmed) ? 
                                                    ` ${moment(orderConfirmed.createdAt, 'YYYY-MM-DDTHH:mm:ss.ZZZ').format('DD MMMM YYYY hh:mm A')}`
                                                    : 
                                                    ''
                                            }
                                        </label>
                                    </div>
                                    {
                                        !isEmpty(orderConfirmed) && orderConfirmed.status.codeName === 'PENDIENTE_DE_PAGO' && (
                                            <span>
                                                <div style={{ marginTop: '10px' }}>
                                                    Fecha limite de pago: <label>{moment(orderConfirmed.createdAt, 'YYYY-MM-DDTHH:mm:ss.ZZZ').add(1, 'day').format('DD MMMM YYYY hh:mm A')}</label>
                                                </div>
                                                <div style={{ marginBottom: '10px' }}>
                                                    Recuerda que tienes 24 horas para hacer tu pago.
                                                </div>
                                                {
                                                    !isEmpty(paymentMethods) && paymentMethods.map(pay => (
                                                        <div key={`pm_${pay.id}`}>
                                                            <div>
                                                                Método de pago: <label className="font-weight-bold">{pay.name}</label>
                                                            </div>
                                                            <div>
                                                                {pay.accountPrefix}
                                                            </div>
                                                            <div>
                                                                {pay.accountNumber}
                                                            </div>
                                                            <div>
                                                                {pay.entityName}
                                                            </div>
                                                            <div style={{ marginBottom: '10px' }}>
                                                                {pay.ownerName}
                                                            </div>
                                                        </div>
                                                    ))
                                                }

                                            </span>
                                        )
                                    }
                                    <div style={{ marginTop: '10px' }}>
                                        {!isEmpty(orderConfirmed) && orderConfirmed.status.codeName === 'PAGADO' ? 'Monto pagado: ' : 'Monto a pagar: '}
                                        <label className="font-weight-bold"> 
                                            <CurrencyFormat
                                                value={` ${orderConfirmed.total}`}
                                                displayType="text"
                                                thousandSeparator
                                                prefix="$"
                                            />
                                        </label>
                                    </div>
                                    {!isEmpty(orderConfirmed) && orderConfirmed.status.codeName === 'PAGADO' && (
                                        <div style={{ marginTop: '10px' }}>
                                            {'Método de pago: '}
                                            <label className="font-weight-bold"> 
                                                {orderConfirmed.paymentType === 'card' ? ' Pago en línea' : 'Transferencia / Depósito'}
                                            </label>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <img
                                        src={orderEnvioImg}
                                        alt="Dirección de envío"
                                        className="img-fluid mx-auto d-block"
                                        width="240px"
                                        height="111px"
                                        style={{ marginBottom: '20px' }}
                                    />
                                    <div
                                        className="font-weight-bold"
                                        style={{ marginBottom: '20px' }}
                                    >
                                        <label style={{ fontSize: '16px', color: '#e52e6a' }}>DIRECCIÓN DE ENVÍO</label>
                                    </div>
                                    <div>
                                        <label className="font-weight-bold">{props.user.firstName} {props.user.lastName}</label>
                                    </div>
                                    <div style={{ marginBottom: '10px' }}>
                                        {!isEmpty(orderConfirmed) && (`
                                            ${orderConfirmed.userAddress.calle} 
                                            ${orderConfirmed.userAddress.numeroExterior} 
                                            ${orderConfirmed.userAddress.numeroInterior} 
                                            ${orderConfirmed.userAddress.colonia} 
                                            ${orderConfirmed.userAddress.cp} 
                                            ${orderConfirmed.userAddress.entreCalles} 
                                            ${orderConfirmed.userAddress.localidad} 
                                            ${orderConfirmed.userAddress.municipio} 
                                            ${orderConfirmed.userAddress.state.nomEstado} 
                                            ${orderConfirmed.userAddress.country.nameEn}
                                        `)}
                                    </div>
                                    <div>
                                        La dirección no podrá ser modificada, cualquier aclaración al correo <a href={`mailto:${settings ? settings.value : ''}`}>{settings ? settings.value : ''}</a>
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <div
                                        className="font-weight-bold"
                                        style={{ marginBottom: '10px' }}
                                    >
                                        <label
                                            style={{ fontSize: '16px', color: '#e52e6a' }}
                                        >
                                            {!isEmpty(orderConfirmed) ? orderConfirmed.supplier.razonSocial : ''}
                                        </label>
                                    </div>
                                    <div style={{ marginBottom: '10px' }}>
                                        Fecha de recepción:
                                    </div>
                                    <div style={{ marginBottom: '10px' }}>
                                        <label className="font-weight-bold">
                                            {
                                                !isEmpty(orderConfirmed) ? 
                                                    moment(orderConfirmed.createdAt, 'YYYY-MM-DDTHH:mm:ss.ZZZ').format('DD MMMM YYYY hh:mm A') 
                                                    : 
                                                    ''
                                            }
                                        </label>
                                    </div>
                                    <div className="text-center">
                                        {
                                            !isEmpty(orderConfirmed) && orderConfirmed.lineItems.map(item => (
                                                <div key={item.id}>
                                                    <div
                                                        className="product-image-order-confirmed"
                                                        style={{ marginBottom: '150px' }}
                                                    >
                                                        <img
                                                            src={!isEmpty(item.product.gallery) ? head(item.product.gallery).fileName : getUrlOfDefaultProductImage()}
                                                            alt={item.product.name}
                                                            className="img-fluid mx-auto d-block"
                                                        />
                                                    </div>
                                                    <div>
                                                        <label className="font-weight-bold">{item.product.name}</label>
                                                        {!isEmpty(item.productVariant) && (
                                                            <div>
                                                                {!isEmpty(item.productVariant.firstOption.label) && (
                                                                    <span>{item.productVariant.firstOption.label}: <label>{item.productVariant.firstOption.value} </label></span>
                                                                )}
                                                                {!isEmpty(item.productVariant.secondOption.label) && (
                                                                    <span> - {item.productVariant.secondOption.label}: <label>{item.productVariant.secondOption.value} </label></span>
                                                                )}
                                                                {!isEmpty(item.productVariant.thirdOption.label) && (
                                                                    <span> - {item.productVariant.thirdOption.label}: <label>{item.productVariant.thirdOption.value}</label></span>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        Cantidad: <label className="font-weight-bold">{item.quantity}</label> - 
                                                        Importe: <label className="font-weight-bold"> 
                                                            <CurrencyFormat
                                                                value={` ${item.subtotal}`}
                                                                displayType="text"
                                                                thousandSeparator
                                                                prefix="$"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </CardBody>
                            </Card>
                            <Card>
                                <CardBody>
                                    <div className="text-right">
                                        <div style={{ marginBottom: '10px' }}>
                                            Subtotal: <label className="font-weight-bold">
                                                <CurrencyFormat
                                                    value={!isEmpty(orderConfirmed) ? orderConfirmed.subtotal : ''}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </label>
                                        </div>
                                        <div style={{ marginBottom: '10px' }}>
                                            Envío: <label className="font-weight-bold">
                                                <CurrencyFormat
                                                    value={!isEmpty(orderConfirmed) ? orderConfirmed.deliveryCost : ''}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </label>
                                        </div>
                                        <div style={{ marginBottom: '20px' }}>
                                            Total con envío: <label className="font-weight-bold">
                                                <CurrencyFormat
                                                    value={!isEmpty(orderConfirmed) ? orderConfirmed.total : ''}
                                                    displayType="text"
                                                    thousandSeparator
                                                    prefix="$"
                                                />
                                            </label>
                                        </div>
                                    </div>
                                    <div className="text-center">
                                        <div style={{ marginBottom: '20px' }}>
                                            ¡Gracias por comprar en <label style={{ color: '#e52e6a' }}>Vendora!</label>
                                        </div>
                                        <div>
                                            Si tienes alguna duda o comentario sobre la transacción favor de enviar un correo a <a href={`mailto:${settings ? settings.value : ''}`}>{settings ? settings.value : ''}</a>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" className="btn btn-success btn-rounded waves-effect waves-light mb-2 mr-2" onClick={goToOrders}>Aceptar</Button>
                    </ModalFooter>
                </Modal>
            </div>
        </React.Fragment>
    )
}

const mapStatetoProps = (state) => {
    return {
        user: state.Login.user
    }
}

export default connect(mapStatetoProps, {})(withRouter(FormPage))
